/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_AcceptInputs */

const en_privacy_section_4_accept = /** @type {(inputs: Privacy_Section_4_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you accept`)
};

const lv_privacy_section_4_accept = /** @type {(inputs: Privacy_Section_4_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja pieņemat`)
};

/**
* | output |
* | --- |
* | "If you accept" |
*
* @param {Privacy_Section_4_AcceptInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_accept = /** @type {((inputs?: Privacy_Section_4_AcceptInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_AcceptInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_accept(inputs)
	return en_privacy_section_4_accept(inputs)
});